import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/login/index.vue'
import IPT from '../views/IPT.vue'
import Writing from '../views/Writing'
import Project from '../views/Project.vue'
import VoiceRecognition from '../views/VoiceRecognition.vue'
import Profile from '../views/Profile.vue'
import Feature from '../views/Writing/featureDialog.vue'
import PdfView from '../views/Writing/pdfvVew.vue'
import Process from '../views/Process/index.vue'
import Solution from '../views/Process/solutionDetail.vue'
import Patent from '../views/Process/patent.vue'
import SimilarPatents from '../views/Process/similarPatents.vue'
const routes = [
  {
    path: '/',
    component: () => import('@/layouts/default/index.vue'),
    children: [
      { path: '/', redirect: '/ipt' },
      {
        path: '/ipt',
        name: 'IPT',
        component: IPT,
        meta: {
          title: '创新激发-首页',
          permissions: ['innopara@ipt@dashboard']
        }
      },
      {
        path: '/process',
        name: 'Process',
        component: Process,
        meta: {
          title: '创新激发-技术路径分析'
        }
      },
      {
        path: '/writing',
        name: 'Writing',
        component: Writing,
        meta: {
          title: '交底书完善-内容录入'
        }
      },
      {
        path: '/feature',
        name: 'Feature',
        component: Feature,
        meta: {
          title: '创新激发-专利详情'
        }
      },
      {
        path: '/pdf',
        name: 'PdfView',
        component: PdfView,
        meta: {
          title: '创新激发-专利详情'
        }
      },
      {
        path: '/project',
        name: 'Project',
        component: Project,
        meta: {
          title: '创新激发-项目管理',
          permissions: ['innopara@ipt@project']
        }
      },
      {
        path: '/voice',
        name: 'VoiceRecognition',
        component: VoiceRecognition
      },
      {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta: {
          title: '个人信息'
        }
      },
      {
        path: '/solution',
        name: 'Solution',
        component: Solution,
        meta: {
          title: '创新激发-解决方案详情'
        }
      },
      {
        path: '/patent',
        name: 'Patent',
        component: Patent,
        meta: {
          title: '创新激发-专利解读'
        }
      },
      {
        path: '/similar-patents',
        name: 'SimilarPatents',
        component: SimilarPatents,
        meta: {
          title: '创新激发-相关专利'
        }
      },
      {
        path: '/401',
        component: () => import('@/views/error/401'),
        hidden: true
      },
      {
        path: '/404',
        component: () => import('@/views/error/404'),
        hidden: true
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录'
    }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '创新激发'
  next()
})

export default router